import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import {
  PROJECT_DETAILS__SUB_NAV_TITLES,
  APP_DETAILS__SUB_NAV_TITLES,
} from 'sh-www/constants/routes/project-details';
import { APPLICATION } from 'sh-www/models/application';


class ProjectDetailsPitchRoute extends Route {
  @service router;
  @service session;

  /** @inheritDoc */
  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/project/:id/pitch/');
    this.controllerFor('project-details').updateSubNavState(PROJECT_DETAILS__SUB_NAV_TITLES.PITCH);
  }

  /** @inheritDoc */
  redirect(model) {
    if (APPLICATION.STATUS.PENDING === model.status && this.session.currentUser.isSeller) {
      this.router.replaceWith(EMBER_ROUTE_NAMES.POSTING__APP, model.assignment.slug, model.pitch.applicationId, {
        queryParams: { tab: APP_DETAILS__SUB_NAV_TITLES.PITCH },
      });
    }
  }
}

export default ProjectDetailsPitchRoute;
